import type { Member, Members } from "./useMembers";

export const DEACTIVATED_MEMBER_DISPLAY_NAME = "Deactivated User";

export const DEACTIVATED_MEMBER_OWNER_TOOLTIP = DEACTIVATED_MEMBER_DISPLAY_NAME;

export function deactivatedMemberOwner(): Member {
  return {
    fullName: DEACTIVATED_MEMBER_DISPLAY_NAME,
  } as unknown as Member;
}

export function getMemberOwnerTooltipContent(
  owner: unknown,
): string | undefined {
  if (!owner || typeof owner !== "object") {
    return undefined;
  }
  const fullName = (owner as { fullName?: unknown }).fullName;
  if (typeof fullName === "string" && fullName.trim().length > 0) {
    return fullName.trim();
  }
  return undefined;
}

interface HydrateMemberOptions {
  /**
   * When true, a missing member is only replaced with the deactivated placeholder
   * after members have loaded (`isMembersPending` is false). Avoids flashing
   * deactivated avatars while the members query is in flight.
   */
  deferDeactivatedUntilMembersResolve?: boolean;
  /** Pass `useMembers().isPending` when using `deferDeactivatedUntilMembersResolve`. */
  isMembersPending?: boolean;
}

export function hydrateMemberFromLookup(
  members: Members,
  ownerId: number | string | null | undefined,
  options?: HydrateMemberOptions,
): Member | undefined {
  if (ownerId == undefined || ownerId === "") {
    return undefined;
  }
  const key = String(ownerId);
  const fromLookup = members[key];
  if (fromLookup) {
    return fromLookup;
  }
  if (
    options?.deferDeactivatedUntilMembersResolve &&
    options.isMembersPending
  ) {
    return undefined;
  }
  return deactivatedMemberOwner();
}
